import { createFileRoute, Navigate, useParams } from "@tanstack/react-router";
import { useIssueByKey } from "../lib/issues";
import { Skeleton } from "../components/ui/skeleton";
import { isNotFound, NotFound, Unavailable } from "../components/ui/states";
import { strings } from "../lib/strings";

/**
 * An issue's short address, `/admin/i/<KEY-N>` (BUILD_SPEC §10.3): whatever key it is given, an old one included, it
 * opens the issue's own page as the issue is keyed now; or says the issue isn't there, or couldn't be loaded.
 */
function ShortIssueLink() {
  const { issueKey } = useParams({ from: "/admin/i/$issueKey" });
  const found = useIssueByKey(issueKey);
  if (found.isLoading) return <Skeleton className="mx-auto mt-8 h-7 w-1/2" />;
  if (found.data === undefined)
    return (
      <div className="mx-auto max-w-3xl px-6 py-12">
        {isNotFound(found.error) ? (
          <NotFound what={strings.issues.drawer.thisIssue} page />
        ) : (
          <Unavailable what={strings.issues.drawer.thisIssue} onRetry={() => void found.refetch()} page />
        )}
      </div>
    );
  const { key } = found.data.issue;
  return (
    <Navigate
      to="/admin/p/$projectKey/$issueKey"
      params={{ projectKey: key.slice(0, key.lastIndexOf("-")), issueKey: key }}
      replace
    />
  );
}

export const Route = createFileRoute("/admin/i/$issueKey")({ component: ShortIssueLink });
